import React from "react"
import { Container, Grid, Button } from "semantic-ui-react"
import { Link } from "react-router-dom"
import "./Overview.css"

import { ReactComponent as CovidShieldIcon } from "uikit/Icons/covid-shield.svg"
import { ReactComponent as CovidWashIcon } from "uikit/Icons/covid-wash.svg"
import { ReactComponent as CovidMaskIcon } from "uikit/Icons/covid-mask.svg"

export class OverviewCOVID extends React.Component {
  render = () => {
    const { nextUrl, plan } = this.props
    return (
      <>
        <div
          style={{
            padding: "1em",
            backgroundColor: "#FFD500",
            color: "black",
            fontWeight: "bold",
            textAlign: "right",
            height: "5.45em"
          }}
        >
          <div style={{ float: "left" }}>
            <CovidShieldIcon
              style={{
                height: "40px",
                width: "40px",
                marginRight: "0.5em"
              }}
            />
            <CovidWashIcon
              style={{
                height: "40px",
                width: "40px",
                marginRight: "0.5em"
              }}
            />
            <CovidMaskIcon
              style={{
                height: "40px",
                width: "40px",
                marginRight: "0.5em"
              }}
            />
          </div>
          <div style={{ float: "left", paddingTop: "0.55em" }}>
            <span>COVID Relief Planning</span>
          </div>
          {/* <Button
            href="https://help.savvifi.com/en/articles/4048454-how-to-use-savvi-s-covid-relief-planning-assistant"
            target="_blank" rel="noopener noreferrer"
            style={{ backgroundColor: "#FDF2BA" }}
          >
            How to use
          </Button> */}
          <Button
            href="https://help.savvifi.com/en/collections/2289225-covid-19-educational-resources"
            target="_blank"
            rel="noopener noreferrer"
            color="black"
          >
            Crisis education center→
          </Button>
        </div>
        <Container textAlign="center" className="white">
          <Grid centered stackable className="overview_maindiv">
            <Grid.Row style={{ paddingBottom: "0px" }}>
              <Grid.Column textAlign="center">
                <h2 className="overview__Heading">Welcome!</h2>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ paddingTop: "0px" }}>
              <Grid.Column
                className="overview__Description"
                width={14}
                textAlign="center"
              >
                <p className="overview__DescriptionText">
                  We understand that this is a difficult time. Together let’s
                  create a complimentary financial plan with SAVVI to help you
                  Weather the Storm.
                </p>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{}}>
              <Grid.Column>
                <div className="overview_title">What's Next?</div>
                <p>
                  From here it will take you an additional 15-30 minutes to
                  create a personalized action plan so you can have some clarity
                  and more confidence about your money during the COVID-19
                  pandemic. After creating your account, you can come back at
                  any time to complete the process. There’s no pressure to
                  finish it all in one sitting; we will work at your pace. In
                  the interim we have helpful Educational Resources with tips,
                  resources and strategies you can use right away.
                </p>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row centered columns={3}>
              <Grid.Column>
                <div className="overview_title">Organize</div>
                <p>
                  The Organize function allows you to collect all your financial
                  accounts together in one place. At any given time, you can see
                  your household balance sheet: your assets, liabilities and net
                  worth. Here you can assess your cash cushion, debts and other
                  investment accounts that you may need to access to provide
                  income before you’re back to work. You can choose to link your
                  accounts using your online login credentials, for automated
                  up-to-date balances, or you can add and update your accounts
                  manually.
                </p>
              </Grid.Column>
              <Grid.Column>
                <div className="overview_title">Understand</div>
                <p>
                  The Understand function gives you a sense of where your money
                  goes. We take into account your typical income (before your
                  layoff or furlough/what you expect when you’re back to work)
                  and then account for your current reduced income. We give you
                  a high-level look with the Big Picture; then specific Insights
                  into your debt, savings, housing costs, and cash reserves.
                  Here you can help make sense of committed expenses and to
                  think about areas where you might be able to improve your
                  spending until you’re back to work. If you’ve previously used
                  SAVVI, this process will feel familiar. We’ve designed this
                  experience to help you adjust to unemployment insurance
                  income.
                </p>
              </Grid.Column>
              <Grid.Column>
                <div className="overview_title">Plan</div>
                <p>
                  The Plan section of SAVVI is the most powerful step of the
                  process. This is where you receive actionable, tax-efficient
                  insights about your money. Once here you’ll see a “Weather the
                  Storm” goal that gives you a specific game plan for your time
                  out of work. You’ll receive advice on how much you may need to
                  cut back spending, access financial accounts or take out
                  loans. We take into account specific opportunities to take a
                  loan or withdrawal from your current or past retirement plan
                  accounts. It’s understandable if long-term goals like
                  retirement aren’t your first priority right now, but they
                  still matter and can be included in this step.
                </p>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ paddingBottom: "0" }}>
              <Grid.Column>
                <div className="overview_title">
                  A few more important things you need to know...
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <ul className="overview__List">
                  <li>
                    The advice you’re going to get…it’s personalized and
                    independent. We are committed to putting your best interests
                    first.
                  </li>
                  <li>We keep your data secure with layers of protections.</li>
                  <li>
                    This can help you weather the storm during the COVID-19
                    pandemic, but once you're back to work, our traditional
                    SAVVI experience may serve you in the future. The COVID
                    Relief Planning Tool is available at no cost to eligible
                    individuals for {plan.interval}. Individuals who would like
                    to continue and/or expand their relationship with SAVVI may
                    elect to do so after {plan.interval}, at which time SAVVI's
                    stated fee will apply.
                  </li>
                  <li>
                    The agreements you’re about to see acknowledge our promises
                    to you.
                  </li>
                </ul>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <div className="overview_details">
                  <p>
                    Ready? Okay… Review. Accept. Go! Let’s Weather the Storm
                    together!
                  </p>
                  <br />
                  <Link to={nextUrl} className="navlink">
                    <Button
                      primary
                      size="big"
                      className="overview_Button"
                      data-testid="continue"
                    >
                      Continue
                    </Button>
                  </Link>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </>
    )
  }
}
